export function backendUrl() {
    //return "http://localhost:8080/api/v3";
    return "https://q1.interb2b.com:8759/api/v3"
}

export function ownStyleCSSUrl() {
    return backendUrl() + "/style.css";
}
